import { render, staticRenderFns } from "./ReportAnswerModal.vue?vue&type=template&id=b94ac386"
import script from "./ReportAnswerModal.vue?vue&type=script&lang=js"
export * from "./ReportAnswerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports